/* eslint-disable */
import Swiper from 'swiper/bundle';

const pagePresentation = document.querySelector('body.template-presentation');


if (pagePresentation) {

  console.log('presentation');
  var swiper = new Swiper('.swiper-container-presentation', {
    direction: 'horizontal',
    slidesPerView: 1.1,
    spaceBetween: 28,
    navigation: {
      nextEl: '#notre-histoire >.container > .wrapper-swiper-btns-presentation > .next',
      prevEl: '#notre-histoire >.container > .wrapper-swiper-btns-presentation > .prev',
    },
    breakpoints: {
      550: {
        slidesPerView: 2.1
      },
      991: {
        slidesPerView: 3.1
      },
      1200: {
        slidesPerView: 4
      }
    }
  });
}


// WEBPACK FOOTER //
// ./scripts/presentation.js